<template>
  <!-- 拒單 -->
  <cus-dialog>
    <template v-slot:body>
      <div style="padding: 0 4px">
        <cus-radio-column
          :radioList="radioList"
          v-model:selectValue="select_reason"
          v-model:input_reason="input_reason"
        ></cus-radio-column>
      </div>
    </template>
    <template v-slot:footer>
      <div class="d-flex">
        <cus-button text="取消" color="white" :width="50" @click="close"></cus-button>
        <cus-button
          text="確定"
          color="blue"
          :width="50"
          :disabled="!select_reason"
          @click="submit({ input_reason, select_reason })"
        ></cus-button>
      </div>
    </template>
  </cus-dialog>
</template>
<script>
import { inject, ref, reactive } from 'vue';
import { useGetters, useActions } from '@/utils/mapStore';

export default {
  name: 'reject-order',
  setup() {
    // const { proxy } = getCurrentInstance();
    //接受provide值
    const { cusProps } = inject('cusProps');
    const close = inject('close');
    const submit = inject('submit');

    //建立清單
    const radioList = reactive([]);
    const getReasonList = useGetters('handleOrder', ['getReasonList']);
    const doReasonList = useActions('handleOrder', ['doReasonList']);
    const list = async () => {
      await doReasonList();
      getReasonList.value.order_reject_reason.forEach((reason) => {
        radioList.push({ label: reason, value: reason });
      });
    };
    list();

    //建立參數
    const input_reason = ref('');
    const select_reason = ref(null);

    return {
      close,
      submit,
      cusProps,
      radioList,
      input_reason,
      select_reason,
    };
  },
};
</script>
